module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAPCAYAAAD+pA/bAAABN0lEQVQ4T7WSsUrEQBCGZ8DCF7AQexG0ESsrO89n0CKzSWGnwjVyjTa2ooJgtztbqG8gXhMrKzsrQZBoaSNYpciOGLLgnckld8Zt9/+/b2d3Ef554Th8rfU+AMwopbpNe40FWusTRNwtwH0i6jSRNBIwc09EjoaAV0S0WSepFTDztohcVIDOiMhPVRoZKdBabyDizahTImI3CILjqkylwFq75py7q7uC731E3AuC4LQsWyqw1i455x6bwH1GRLaUUpfDnV8CZp4TkWcAmB5HUGQ7RNT/2RsQxHE8lSTJKwDMTgDPK1mWLURR9OT7AwJjzAMArEwKL3qfzrnFMAzf8vfxMGPMPQCs/hHu6+8iMq+U+sgFxphbAFhvCe4xL2maLqMxZgcASr9YC8JzZOYDETlsAVaGuP4CWghm5QtcnaEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_share_about_close.png
// module id = qD7B
// module chunks = 0